export const PUBLIC_APP_URL = process.env.REACT_APP_PUBLIC_APP_URL;
export const ADMIN_APP_URL = process.env.REACT_APP_ADMIN_APP_URL;
export const AUTH_TOKEN_NAME = 'na_admin_token';
export const PRODUCT_NAME = 'National Application Admin Portal';
export const AUTO_LOGOUT_TIMEOUT =  1000 * 60 * 5; // Logout after 5 minutes by default as per UN cybersecurity standards;

// If signin with itdb is enabled, then we'll include ITDB in the login button text
export const SIGNIN_WITH_ITDB = process.env.REACT_APP_SIGNIN_WITH_ITDB;

export const SYSTEM_DEFAULT_COUNTRY = process.env.REACT_APP_SYSTEM_DEFAULT_COUNTRY;
export const SYSTEM_UNION_CODE = process.env.REACT_APP_SYSTEM_UNION_CODE;
export const SENDER_ID = process.env.REACT_APP_SENDER_ID;
export const ADMINISTRATION_NAME = process.env.REACT_APP_ADMINISTRATION_NAME;
export const ADMINISTRATION_LOGO_URL = process.env.REACT_APP_ADMINISTRATION_LOGO_URL;

export const API_URL = process.env.REACT_APP_API_URL;
export const FONTAWESOME_VARIANT = 'fa-light';

// OAuth config
export const AUTHENTICATION_CODE_ENDPOINT = process.env.REACT_APP_AUTHENTICATION_CODE_ENDPOINT;
export const AUTHENTICATION_TOKEN_ENDPOINT = process.env.REACT_APP_AUTHENTICATION_TOKEN_ENDPOINT;
export const OAUTH_CLIENT_ID = process.env.REACT_APP_OAUTH_CLIENT_ID;
export const OAUTH_CLIENT_SECRET = process.env.REACT_APP_OAUTH_CLIENT_SECRET;
// OAuth config
